export { default } from './FeatureComparisonTable'
